import api from "../api/axios"

export const getProducts = async () => {
  const res = await api.get("/products")
  return res.data
}

/** Scan POS : GET /api/products/by-barcode?code=… — 404 si introuvable */
export const getProductByBarcode = async (code) => {
  const res = await api.get("/products/by-barcode", { params: { code } })
  return res.data
}

export const createProduct = async (data) => {
  const res = await api.post("/products", data)
  return res.data
}

export const updateProduct = async (id, data) => {
  const res = await api.put(`/products/${id}`, data)
  return res.data
}

export const deleteProduct = async (id) => {
  const res = await api.delete(`/products/${id}`)
  return res.data
}
